import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function Expander({ icon: I, title, badge, testId, children, tile = false }) {
  const [open, setOpen] = useState(false);
  return (
    <section className={`mm-card mm-rise !p-0 min-w-0 ${tile ? "overflow-hidden" : ""}`} data-testid={testId}>
      <button className={tile ? "flex h-[112px] w-full min-w-0 flex-col items-center justify-center gap-2 p-2 text-center sm:h-[128px]" : "bp-expand-toggle w-full p-4 text-left sm:p-5"} onClick={() => setOpen(!open)} aria-expanded={open} data-testid={`${testId}-toggle-button`}>
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full" style={{ background: "color-mix(in srgb, var(--ac) 14%, transparent)", color: "var(--ac)" }}><I className="h-5 w-5" /></span>
        <span className={tile ? "text-xs font-semibold leading-tight sm:text-base" : "mm-h2 flex-1 text-base sm:text-lg"}>{title}</span>
        {!tile && badge}
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div key="c" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3, ease: [0.2, 0.8, 0.2, 1] }} className="overflow-hidden">
            <div className="border-t border-[var(--bd)] p-4 sm:p-5" data-testid={`${testId}-content`}>{tile && badge && <div className="mb-2">{badge}</div>}{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
